import { createSelector } from 'reselect';

export const getDeeplinkData = state => state.deeplink;

export const getDeeplinkNavagation = createSelector(
  getDeeplinkData,
  ({ navigation }) => navigation
);

export const getDeeplinkKind = createSelector(
  getDeeplinkData,
  ({ kind }) => kind
);

export const getVerifiedVehicle = createSelector(
  getDeeplinkData,
  ({ verifiedVehicle }) => verifiedVehicle
);
export const getIncompleteVehicle = createSelector(
  getDeeplinkData,
  ({ incompleteVehicle }) => incompleteVehicle
);

export const getApptRevisit = createSelector(
  getDeeplinkData,
  ({ apptRevisit }) => apptRevisit
);

export const getHasServices = createSelector(
  getDeeplinkData,
  ({ hasServices }) => hasServices
);

export const getHasTransportationOptions = createSelector(
  getDeeplinkData,
  ({ hasTransportationOption }) => hasTransportationOption
);

export const getIsDeeplinking = createSelector(
  getDeeplinkData,
  ({ isDeeplinking }) => isDeeplinking
);

export const getIsDeeplink = createSelector(
  getDeeplinkData,
  ({ isDeeplink }) => isDeeplink
);



// WEBPACK FOOTER //
// ./src/store/reducers/deeplink/selectors.js